// To make development faster and more enjoyable, a symlink between the evaluation json files from the evaluation_definitions repo, and
// this folder can be created. JSON files will then be watched and the app will reload on changes, showing modifications immediately,
// rather than reloading through the API.
// Symlinks can be created with:
// jean@jean:~/code/vyla/evaluations/src/definitions$ ln -s /home/jean/code/vyla/evaluation_definitions/definitions/farm_es_v3_evaluator-0-hdr.json .
// jean@jean:~/code/vyla/evaluations/src/definitions$ ln -s /home/jean/code/vyla/evaluation_definitions/definitions/farm_es_v3_evaluator-0-def.json .

// The mapping between form type and the evaluation name and version
// An entry must be defined after creating the symlinks
const localDefinitionsMapping: Record<string, string> = {
  farm_es_v3_evaluator: 'farm_es_v3_evaluator-0'
};


let localDefinitions: Record<string, any> = {};

export const hasLocalDefinition = (formType: string) => {
  if (localDefinitions[formType]) {
    const def = localDefinitions[formType].def;
    const hdr = localDefinitions[formType].hdr;
    return (def && def.data && hdr);
  }
}

export const getLocalDefinition = (formType: string) => {
  const def = localDefinitions[formType].def;
  const hdr = localDefinitions[formType].hdr;
  let mappedDef = {
    ...hdr,
    $schema: "https://eval.nationaldairyfarm.com/dfs-01-draft/schema#",
    definition: { data: def.data, ...def.application.eval }
  };
  return mappedDef;
}

Object.keys(localDefinitionsMapping).forEach((formType) => {
  try {
    localDefinitions[formType] = {
      def: require(`./${localDefinitionsMapping[formType]}-def.json`),
      hdr: require(`./${localDefinitionsMapping[formType]}-hdr.json`),
    };
  } catch (e) {
    // If the json file is not found locally, we end up here and we fail silently - the definition will be loaded through the API
  }
})